export default __webpack_public_path__ + "static/media/close-mobile-burger.fbf721d0.svg";